import { redirectSchema } from "@/router/dtos";
import type { RouteRecordRaw } from "vue-router";
import EditUserPage from "./EditUserPage.vue";
import InvitationsPage from "./InvitationsPage.vue";
import PendingUserActivationPage from "./PendingUserActivationPage.vue";
import UsersPage from "./UsersPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/users/pending/activate/:token",
    name: "activatePendingUser",
    component: PendingUserActivationPage,
    props: (route) => ({
      token: route.params.token,
      redirect: redirectSchema.parse(route.query),
    }),
  },
  {
    // legacy link kept for previously sent invitation/signup emails.
    // remove after 2026-10-01
    path: "/invitations/:token",
    redirect: (to) => ({ name: "activatePendingUser", params: to.params }),
  },
  {
    path: "/users",
    children: [
      {
        path: "",
        name: "users",
        component: UsersPage,
      },
      {
        path: "/users/:id",
        name: "editUser",
        component: EditUserPage,
        props: true,
      },
      {
        path: "/users/invitations",
        name: "invitations",
        component: InvitationsPage,
      },
    ],
  },
];

export default routes;
